<template>
  <div class="home" v-cloak v-show="test">
    <mobileConsult />
    <consult />
    <toTop />
     
    <div class="home-wrapper01">
      <div class="wrapper01-main">
        <div class="text02">出现行业数字化解决方案服务商</div>
        <div class="text01">高效—协同—智能</div>
        <div class="text03"></div>
        <!-- <div class="text03">业务-财务-管理一体化，助力企业数字化转型</div> -->
      </div>
    </div>

    <div class="index_home-wrapper02">
      <div class="wrapper02-main">
        <div class="wrapper02-main01">
          <div><img class="img01" src="../assets/images/home02.png"/></div>
          <div><img class="img02" src="../assets/images/homeadd.png"/></div>
        </div>
        <div class="wrapper02-main02">10年技术沉淀</div>
      </div>
      <div class="wrapper02-main">
        <div class="wrapper02-main01">
          <div><img class="img01" src="../assets/images/home03.png"/></div>
          <div><img class="img02" src="../assets/images/homeadd.png"/></div>
        </div>
        <div class="wrapper02-main02">20年出行行业经验</div>
      </div>
      <div class="wrapper02-main">
        <div class="wrapper02-main01">
          <div><img class="img01" src="../assets/images/home04.png"/></div>
          <div><img class="img02" src="../assets/images/homeadd.png"/></div>
        </div>
        <div class="wrapper02-main02">超过30项软件著作权</div>
      </div>
    </div>


    <!-- pc 出租车和网约车一站式出行解决方案 start-->
    <section class="index_taxi_online_car">
      <!-- <h1>出租车和网约车一站式出行解决方案</h1> -->
      <h1>业务-财务-管理一体化，助力企业数字化转型</h1>
      <div class="digital_solution_case">     
          <div class="solution_item" @click="toPage(1)">
              <div class="solution_text01">资产管理</div>
              <div class="solution_text02">
                <div>车辆资料/车辆资质/车辆年检</div>
                <div>车辆保险/车辆违章/车辆维护</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home05.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
          <div class="solution_item" @click="toPage(2)">
              <div class="solution_text01">司机管理</div>
              <div class="solution_text02">
                <div>司机资料/司机资质/司机订单</div>
                <div>司机协议/司机违章/司机请假签到</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home06.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
          <div class="solution_item" @click="toPage(3)">
              <div class="solution_text01">订单管理</div>
              <div class="solution_text02">
                <div>订单创建/订单终止/订单查询</div>
                <div>订单导出/订单统计</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home07.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
          <div class="solution_item" @click="toPage(4)">
              <div class="solution_text01">财务管理</div>
              <div class="solution_text02">
                <div>用户余额/车主押金/司机保证金</div>
                <div>车主结算/应收待付统计</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home08.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
      </div>

    </section>
    <!-- pc 出租车和网约车一站式出行解决方案 end-->
    
    <!-- mobile  出租车和网约车一站式出行解决方案 start -->
    <section class="mobile_taxi_online_car">
      <h1> 出租车和网约车一站式出行解决方案</h1>
      <div class="mobile_solution_case" @click="toPage01">     
          <div class="mobile_solution_item">
              <div class="solution_text01">资产管理</div>
              <div class="solution_text02">
                <div>车辆资料/车辆资质/车辆年检</div>
                <div>车辆保险/车辆违章/车辆维护</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home05.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
          <div class="mobile_solution_item">
              <div class="solution_text01">司机管理</div>
              <div class="solution_text02">
                <div>司机资料/司机资质/司机订单</div>
                <div>司机协议/司机违章/请假签到</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home06.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
          <div class="mobile_solution_item">
            <div class="solution_text01">订单管理</div>
              <div class="solution_text02">
                <div>订单创建/订单终止/订单查询</div>
                <div>订单导出/订单统计</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home07.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
          <div class="mobile_solution_item">
              <div class="solution_text01">财务管理</div>
              <div class="solution_text02">
                <div>用户余额/车主押金/司机保证金</div>
                <div>车主结算/应收待付统计</div>
              </div>
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home08.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
          </div>
          
      </div>
    </section>
    <!-- mobile  出租车和网约车一站式出行解决方案 end-->
    
      
    <!-- 更有优势的数据可视化工具 -->
    <section class="index_data_visible">
       <h1>更有优势的数据可视化工具</h1>

        <div class="container">
          <div class="swiper-container swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="../assets/images/home09.png" alt="">
                  <div class="swiper-text">人车实时监控</div>
                </div>
                <div class="swiper-slide">
                  <img src="../assets/images/home10.png" alt="">
                  <div class="swiper-text">数据报表集成</div>
                </div>
                <div class="swiper-slide">
                  <img src="../assets/images/home11.png" alt="">
                  <div class="swiper-text">自助式BI分析</div>
                </div>
                <div class="swiper-slide">
                  <img src="../assets/images/home12.png" alt="">
                  <div class="swiper-text">数据可视化大屏</div>
                </div>
            </div>
          </div>  
          
          <div class="swiper-pagination"></div><!-- 前进后退按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>

    </section>


    <!-- pc 海量的模块和服务帮助企业轻松上云 start-->
    <section class="index_module_service">
      <h1>海量的模块和服务帮助企业轻松上云</h1>
      <div class="digital_solution_case">     
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home13.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">资产管理</div>
              <div class="solution_text02">
                <div>用户管理 / 车辆管理</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home14.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">经营管理</div>
              <div class="solution_text02">
                <div>司机协议 / 租赁协议 / 调令协议</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home15.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">运营管理</div>
              <div class="solution_text02">
                <div>排班管理 / 活动管理 / 消息管理</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home16.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">车务管理</div>
              <div class="solution_text02">
                <div>年检 / 保险 / 维修 / 保养 / 事故 / 违章</div>
                <!-- <div>保养 / 事故 / 违章</div> -->
              </div>
              
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home17.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">财务管理</div>
              <div class="solution_text02">
                <div>用户账户 / 司机保证金 / 车主押金</div>
                <div>车主结算 / 支付管理</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home18.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">审批管理</div>
              <div class="solution_text02">
                <div>资产审批 / 经营审批 / 运营审批</div>
                <div>车务审批 / 财务审批</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home19.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">系统设置</div>
              <div class="solution_text02">
                <div>后台用户管理 / 后台角色管理</div>
                <div>系统日志管理</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home20.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">统计管理</div>
              <div class="solution_text02">
                <div>资产统计 / 经营统计 / 运营统计</div>
                <div>财务统计</div>
              </div>
          </div>
      </div>

    </section>
    <!-- pc 海量的模块和服务帮助企业轻松上云 end-->
    
    <!-- mobile  海量的模块和服务帮助企业轻松上云 start -->
    <section class="mobile_module_service">
      <h1> 海量的模块和服务帮助企业轻松上云</h1>
      <div class="mobile_solution_case">     
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home13.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">资产管理</div>
              <div class="solution_text02">
                <div>用户管理/车辆管理</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home14.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">经营管理</div>
              <div class="solution_text02">
                <div>司机协议/租赁协议/调令协议</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home15.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">运营管理</div>
              <div class="solution_text02">
                <div>排班管理/活动管理/消息管理</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home16.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">车务管理</div>
              <div class="solution_text02">
                <div>年检/保险/维修</div>
                <div>保养/事故/违章</div>
              </div>
              
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home17.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">财务管理</div>
              <div class="solution_text02">
                <div>用户账户/司机保证金/车主押金</div>
                <div>车主结算/支付管理</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home18.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">审批管理</div>
              <div class="solution_text02">
                <div>资产审批/经营审批/运营审批</div>
                <div>车务审批/财务审批</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home19.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">系统设置</div>
              <div class="solution_text02">
                <div>后台用户管理/后台角色管理</div>
                <div>系统日志管理</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home20.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">统计管理</div>
              <div class="solution_text02">
                <div>资产统计/经营统计/运营统计</div>
                <div>财务统计</div>
              </div>
          </div>
      </div>
      
    </section>
    <!-- mobile  海量的模块和服务帮助企业轻松上云 end-->


     <!-- pc 为企业数字化提供全方位服务 start-->
    <section class="index_enterprise_digitization_service">
      <h1>为企业数字化提供全方位服务</h1>
      <div class="digital_solution_case">     
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home21.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">人工服务</div>
              <div class="solution_text02">
                <div>电话、工单，售后服务部门随时为你提供迅速响应服务,及时应对客户提出的运营、技术难题。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home22.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">技术支持</div>
              <div class="solution_text02">
                <div>产品手册、操作教程、使用培训、安装帮助一应俱全，为您提供完整的技术指导，使您快速上手。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home23.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">专属定制开发</div>
              <div class="solution_text02">
                <div>强大的技术团队，可根据您的项目需求，为您专属定制开发，满足您全方位的产品需求。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home24.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">效能顾问</div>
              <div class="solution_text02">
                <div>资深行业运营经验，帮助您定位组织问题，制定效能提升方案，提供组织管理升级、咨询服务。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home25.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">1V1一体化服务</div>
              <div class="solution_text02">
                <div>安排专属售后协助您全程为您提供技术指导，提供更佳优质、及时的服务。</div>
              </div>
          </div>
          <div class="solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home26.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">更多服务</div>
              <div class="solution_text02">
                <div>持续根据客户反馈，满足更多疑难问题，以适应您更多服务需求。</div>
              </div>
          </div>
          
      </div>

    </section>
    <!-- pc 为企业数字化提供全方位服务 end-->

    <!-- mobile  为企业数字化提供全方位服务 start -->
    <section class="mobile_enterprise_digitization_service">
      <h1> 为企业数字化提供全方位服务</h1>
      <div class="mobile_solution_case">     
          <div class="module_solution_item">
               <div class="solution_img_wrapper">
                <img  src="../assets/images/home21.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">人工服务</div>
              <div class="solution_text02">
                <div>电话、工单，售后服务部门随时为你提供迅速响应服务,及时应对客户提出的运营、技术难题。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home22.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">技术支持</div>
              <div class="solution_text02">
                <div>产品手册、操作教程、使用培训、安装帮助一应俱全，为您提供完整的技术指导，使您快速上手。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home23.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">专属定制开发</div>
              <div class="solution_text02">
                <div>强大的技术团队，可根据您的项目需求，为您专属定制开发，满足您全方位的产品需求。</div>
              </div>
          </div>
          <div class="module_solution_item">
               <div class="solution_img_wrapper">
                <img  src="../assets/images/home24.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">效能顾问</div>
              <div class="solution_text02">
                <div>资深行业运营经验，帮助您定位组织问题，制定效能提升方案，提供组织管理升级、咨询服务。</div>
              </div>
              
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home25.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">1V1一体化服务</div>
              <div class="solution_text02">
                <div>安排专属售后协助您全程为您提供技术指导，提供更佳优质、及时的服务。</div>
              </div>
          </div>
          <div class="module_solution_item">
              <div class="solution_img_wrapper">
                <img  src="../assets/images/home26.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text01">更多服务</div>
              <div class="solution_text02">
                <div>持续根据客户反馈，满足更多疑难问题，以适应您更多服务需求。</div>
              </div>
          </div>
         
      </div>
      
    </section>
    <!-- mobile  为企业数字化提供全方位服务 end-->


     <!-- 多重安全合规资质 start-->
    <section class="index_fr_prize">
    <h2>多重安全合规资质</h2>
    <ul>
        <li><img src="../assets/images/home27.png" alt=""><p>国家发明专利</p></li>
        <li><img src="../assets/images/home28.png" alt=""><p>高新技术企业</p></li>
        <li><img src="../assets/images/home29.png" alt=""><p>三级等保认证</p></li>
        <li><img src="../assets/images/home30.png" alt=""><p>信息安全管理</p></li>
        <li><img src="../assets/images/home31.png" alt=""><p>信用等级证书</p></li>    
    </ul>
    </section>
    <!-- 多重安全合规资质 end-->

    <!-- 多重安全合规资质 start-->
    <section class="mobile_fr_prize">  
      <h2>多重安全合规资质</h2>
        <div class="fr_prize_box">             
            <div class="fr_prize_item">
            <img src="../assets/images/home27.png" alt="中国大数据企业"><p>国家发明专利</p>
            </div>
            <div class="fr_prize_item">
            <img src="../assets/images/home28.png" alt="软件能力成熟度模型"><p>高新技术企业</p>
            </div>
            <div class="fr_prize_item">
            <img src="../assets/images/home29.png" alt="福布斯"><p>三级等保认证</p>
            </div>
            <div class="fr_prize_item">
            <img src="../assets/images/home30.png" alt="Gartner全球ABI魔力象限"><p>信息安全管理</p>
            </div>
            <div class="fr_prize_item">
            <img src="../assets/images/home31.png" alt="2022IDC"><p>信用等级证书</p>
            </div>
        </div>
    </section> 
    <!-- 多重安全合规资质 end-->

    <!-- 获取方案 start-->
    <section class="free_use_buttton">
        <h3>一站式出行行业数字化解决方案服务商</h3>
        <a @click="toAboutsUs" class="free_use_buttton_btn1"><span>获取方案</span> </a>
        <div class="copy-right">
            &copy;2017-2023 杭州邮鸽网络科技有限公司版权所有  |  <span class="copy-right-number"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">浙ICP备17048614号</a></span>
        </div>
    </section>
    <!-- 获取方案 end-->



    <!-- pc 各行各业数字化转型解决方案 start-->
    <!-- <section class="index_digital_solution">
      <h1>各行各业数字化转型解决方案</h1>
      <div class="digital_solution_case">     
          <div class="solution_item">
              <h4>数字地产</h4>
              <div class="solution_img_box">
              <div class="gjh"></div>
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%9C%B0%E4%BA%A7-nor-min.png" alt="泛地产数据分析,数字化转型,城镇化产业链,数字经营与应用"> 
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%9C%B0%E4%BA%A7-hov-min.png" alt="泛地产数据分析,数字化转型,城镇化产业链,数字经营与应用"> 
              </div>
              <div class="solution_text">
              <span>数字地产</span>
              <span>为行业上下游提供数据底层建设、场景化数据应用、数字经营等系统解决方案</span> 
              <span><a href="https://www.fanruan.com/solutions/qicheng" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
          <div class="solution_item">
              <h4>数字金融</h4>
              <div class="solution_img_box">
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%87%91%E8%9E%8D-nor-min.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%87%91%E8%9E%8D-hov-min.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
              </div>
              <div class="solution_text">
              <span>数字金融</span>
              <span>建立科学的数据增长指标体系，洞悉业务需求，构建大数据分析平台解决方案</span> 
              <span><a href="https://www.fanruan.com/solutions/finance" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
          <div class="solution_item">
              <h4>智慧交通</h4>
              <div class="solution_img_box">
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E4%BA%A4%E9%80%9A-nor-min.png" alt="交通大数据平台,物流大数据平台,物流可视化,智慧数据分析,交通数据化管理">
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E4%BA%A4%E9%80%9A-hov-min.png" alt="交通大数据平台,物流大数据平台,物流可视化,智慧数据分析,交通数据化管理">
              </div>
              <div class="solution_text">
              <span>智慧交通</span>
              <span>集高速、物流、港口等行业为一体的交通数字化转型方案，切实解决数据应用问题</span> 
              <span><a href="https://www.fanruan.com/solutions/transport" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
          <div class="solution_item">
              <h4>智慧银行</h4>
              <div class="solution_img_box">
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%93%B6%E8%A1%8C-nor-min.png" alt="银行BI报表,大数据在银行的应用,银行数据化应用,银行数字化,银行数据管理">
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%93%B6%E8%A1%8C-hov-min.png" alt="银行BI报表,大数据在银行的应用,银行数据化应用,银行数字化,银行数据管理">
              </div>
              <div class="solution_text">
              <span>智慧银行</span>
              <span>构建商业银行管理分析体系，切实解决银行数据应用问题，帮助科学运营和决策</span> 
              <span><a href="https://www.fanruan.com/solutions/bank" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
          <div class="solution_item">
              <h4>数字医药</h4>
              <div class="solution_img_box">
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%8C%BB%E8%8D%AF-nor-min.png" alt="医药健康,医药数字化">
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%8C%BB%E8%8D%AF-hov-min.png" alt="医药健康,医药数字化">
              </div>
              <div class="solution_text">
              <span>数字医药</span>
              <span>基于百强药企转型成功案例，为药企提供行业大数据应用成熟模型和解决方案</span> 
              <span><a href="https://www.fanruan.com/solutions/medi" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
          <div class="solution_item">
              <h4>智慧消费</h4>
              <div class="solution_img_box">
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%9B%B6%E5%94%AE-nor-min.png" alt="零售数据分析,数据决策平台,大数据解决方案,信息化系统,报表软件,bi系统">
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%9B%B6%E5%94%AE-hov-min.png" alt="零售数据分析,数据决策平台,大数据解决方案,信息化系统,报表软件,bi系统">
              </div>
              <div class="solution_text">
              <span>智慧消费</span>
              <span>重构“人、货、场”关系，助力“大消费行业”数字化软着陆</span> 
              <span><a href="https://www.fanruan.com/solutions/retail" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
          <div class="solution_item">
              <h4>数字电力</h4>
              <div class="solution_img_box">
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E7%94%B5%E5%8A%9B-nor-min.png" alt="智慧电力">
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E7%94%B5%E5%8A%9B-hov-min.png" alt="智慧电力">
              </div>
              <div class="solution_text">
              <span>数字电力</span>
              <span>围绕新型电力系统建设，开展电力数据应用实践，释放电力数据能量，助力数字化转型</span> 
              <span><a href="https://www.fanruan.com/solutions/electricity" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
          <div class="solution_item">
              <h4>智能制造</h4>
              <div class="solution_img_box">
              <img class="nor-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%88%B6%E9%80%A0-nor-min.png" alt="智能制造,制造行业数据化">
              <img class="hov-img" src="https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%88%B6%E9%80%A0-hov-min.png" alt="智能制造,制造行业数据化">
              </div>
              <div class="solution_text">
              <span>智能制造</span>
              <span>整合产/供/销/研/财/物等业务数据，建设大数据分析平台，高效数字化管理</span> 
              <span><a href="https://www.fanruan.com/solutions/mfg" target="_blank">查看方案<i class="iconfont icon-xiangyou1"></i></a></span> 
              </div>
          </div>
      </div>

    </section> -->
    <!-- pc 各行各业数字化转型解决方案 end-->

    <!-- mobile 各行各业数字化转型解决方案 start -->
    <!-- <section class="mobile_solution">
      <h1>各行各业数字化转型解决方案</h1>
      <div class="mobile_solution_case">     
          <div class="mobile_solution_item img01" onclick="window.open('https://www.fanruan.com/solutions/qicheng')">
              <span> <a href="https://www.fanruan.com/solutions/qicheng">数字地产<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
          <div class="mobile_solution_item img02" onclick="window.open('https://www.fanruan.com/solutions/finance')">
              <span> <a href="https://www.fanruan.com/solutions/finance">数字金融<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
          <div class="mobile_solution_item img03" onclick="window.open('https://www.fanruan.com/solutions/transport')">
            <span> <a href="https://www.fanruan.com/solutions/transport">智慧交通<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
          <div class="mobile_solution_item img04" onclick="window.open('https://www.fanruan.com/solutions/bank')">
              <span> <a href="https://www.fanruan.com/solutions/bank">智慧银行<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
          <div class="mobile_solution_item img05" onclick="window.open('https://www.fanruan.com/solutions/medi')">
              <span> <a href="https://www.fanruan.com/solutions/medi">数字医药<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
          <div class="mobile_solution_item img06" onclick="window.open('https://www.fanruan.com/solutions/retail')">
              <span> <a href="https://www.fanruan.com/solutions/retail">智慧零售<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
          <div class="mobile_solution_item img07" onclick="window.open('https://www.fanruan.com/solutions/electricity')">
              <span> <a href="https://www.fanruan.com/solutions/electricity">数字电力<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
          <div class="mobile_solution_item img08" onclick="window.open('https://www.fanruan.com/solutions/mfg')">
              <span> <a href="https://www.fanruan.com/solutions/mfg">智能制造<i class="iconfont icon-xiangyou1"></i></a> </span>
          </div>
      </div>

    </section> -->
    <!-- mobile 各行各业数字化转型解决方案 end-->

  </div>
</template>

<script>
import $ from 'jquery'
import consult from '../components/consult.vue'
import mobileConsult from '../components/mobileConsult.vue'
import toTop from '../components/toTop.vue'

import { Swiper } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'


export default {
  name: 'home',
  components:{
    toTop,
    consult,
    mobileConsult,
    
  },
  data(){
    return{
      test:false,
    }
  },
  mounted(){
    setTimeout(()=>{
      this.test = true;
    },100)
    
    $('body,html').animate({scrollTop: 0}, 1);

    setTimeout(()=>{
      this.swiper = new Swiper(".swiper-container", {
        slidesPerView: "2",
        effect: 'coverflow',
        initialSlide: 1,
        speed: 1000,
        observer: true,
        centeredSlides: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 10,
            depth: 400,
            modifier: 2,
            slideShadows: false
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        loop: true,
        loopAdditionalSlides: 10,
        loopedSlides: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            
        },
      });
    },500)

    

    $(".solution_item").mouseover(function() {
        $(".solution_item").children("img").css("filter", "none")
        $(this).children("h4").css("visibility", "hidden")
        $(this).children(".solution_text").css("display", "flex")
        $(".solution_item p").css("display", "block")
    })
    $(".solution_item").mouseout(function() {
        $(this).children("h4").css("visibility", "visible")
        $(this).children(".solution_text").css("display", "none")
        $(".solution_item p").css("display", "none")
    })

  },
  methods: {
    toAboutsUs(){
      this.$router.push('/contactus')
    },
    toPage(type){
      this.$router.push({ path: '/productservice', query: { type: type }});
    },
    toPage01(){
      this.$router.push({ path: '/productservice' });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
[v-cloak]{
  display: none;
}

.home{
  width:100%;
  .home-wrapper01{
    width: 100%;
    height: 35.42rem;
    background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/home01.png');
    background-size: 100% 100%;
    .wrapper01-main{
      margin-left: 20rem;
      padding-top: 7.4rem;
      .text01{
        color: rgb(0, 105, 234);
        font-family: PingFang SC;
        font-size: $fontSize24;
        font-weight: 400;
        line-height: $fontSize36;
        letter-spacing: 0px;
        text-align: left;
        margin-top: $fontSize45;
      }
      .text02{
        color: rgb(0, 105, 234);
        font-family: PingFang SC;
        font-size: 2.3rem;
        font-weight: 400;
        line-height: $fontSize45;
        letter-spacing: 0px;
        text-align: left;
        font-weight: 500;
      }
      .text03{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize20;
        font-weight: 500;
        line-height: $fontSize30;
        letter-spacing: 0px;
        text-align: left;
        margin-top: $fontSize30;
      }
    }
  }
}
.index_home-wrapper02{
  display: flex;
  justify-content: space-around;
  margin-top: 4rem;
  padding: 0 20rem;
  padding-bottom: 4rem;
  .wrapper02-main01{
    display: flex;
    align-items: center;
    justify-content: center;
    .img01{
      width: 6.65rem;
      height: 6.875rem;
    }
    // .img02{
    //   width: 2.2rem;
    //   height: 6.875rem;
    // }
  }
  .wrapper02-main02{
    margin-top: 1rem;
    font-size: $fontSize18;
    color: rgb(102, 102, 102);
  }
}
.copy-right-number>a {
  color: #0069EA;
}
/*pc  出租车和网约车一站式出行解决方案  */ 
.mobile_taxi_online_car{
  display: none;
}
.index_taxi_online_car{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 40.3158rem;
  width: 100%;
  background-color: rgb(239, 245, 255);
  h1{
    color: rgb(51, 51, 51);
    font-family: PingFang SC;
    font-size: $fontSize45;
    font-weight: 500;
    padding: 3rem 0;
  }
  .digital_solution_case {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    height: 37.7368rem;
    width: 100%;
    .solution_img_box {
      height: 16.8421rem;
      width: 21.3158rem;
      margin-right: 1.5263rem;
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .solution_item {
      cursor: pointer;
      height: 25.6875rem;
      width: 21.3158rem;
      margin: .6316rem;
      border-radius: 6px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .solution_text01{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize32;
        font-weight: 500;
        margin-top: 3.125rem;
        margin-bottom: 1.2rem;
      }
      .solution_text02{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize14;
        text-align: center;
      }
      .solution_img_wrapper{
        width: 14.625rem;
        height: 10.5rem;
        margin-top: 2.8rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .solution_item:hover{
      background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/home-bg01.png');
      background-size: cover;
    }
  }
}

/* pc 更有优势的数据可视化工具   */ 
.index_data_visible{
  width: 100%;
  height: 860px;
  background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/home-bg02.png');
  background-size: cover;
  h1{
    color: rgb(255, 255, 255);
    font-family: PingFang SC;
    font-size: $fontSize45;
    font-weight: 500;
    text-align: center;
    margin: 0;
    padding: 80px 0;
  }
  .container {
    width: 1600px;
    padding: 0;
    position: relative;
  }
  .swiper {
    width: 100%;
    height: 510px;
  }
  .swiper .swiper-slide {
    text-align: center;
    font-size: 16px;
    height: 500px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    cursor: pointer;
  }
 
  .swiper .swiper-slide img{
      // width: 100%;
      // height: 80%;
      width: 720px;
      height: 428px;
  }
  .swiper-text{
    color: rgb(255, 255, 255);
    font-family: PingFang SC;
    font-size: 24px;
    z-index: 2;
    position: absolute;
    bottom: 0;
  }
  /deep/ .swiper-pagination-bullet-active{
    background: #ffffff;
  } 
  .swiper-button-prev, .swiper-button-next{
    top: 94%;
    width: 50px;
    height: 50px;
  }
  .swiper-button-prev{
    left: 700px;
    background: url('../assets/images/home-left.png');
    background-size: 100% 100%;
  }
  .swiper-button-next{
    right: 700px;
    background: url('../assets/images/home-right.png');
    background-size: 100% 100%;
  }
  .swiper-pagination{
    position: static;
    width: 80px;
    display: flex;
    justify-content: space-around;
    margin: 30px auto;
  }
}

/*pc  海量的模块和服务帮助企业轻松上云  */ 
.mobile_module_service{
  display: none;
}
.index_module_service{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 40.3158rem;
  width: 100%;
  // background-color: rgb(239, 245, 255);
  h1{
    color: rgb(51, 51, 51);
    font-family: PingFang SC;
    font-size: $fontSize45;
    font-weight: 500;
    padding: 3rem 0;
  }
  .digital_solution_case {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    // height: 37.7368rem;
    width: 100%;
    .solution_img_box {
      height: 16.8421rem;
      width: 21.3158rem;
      margin-right: 1.5263rem;
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .solution_item {
      height: 16.8421rem;
      width: 21.3158rem;
      margin: .6316rem;
      box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 0.5);
      border-radius: 8px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .solution_text01{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize32;
        font-weight: 500;
        margin-top: 1.125rem;
        margin-bottom: 1.2rem;
      }
      .solution_text02{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize14;
        text-align: center;
      }
      .solution_img_wrapper{
        width: 4.16667rem;
        height: 4.16667rem;
        margin-top: 2.8rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .solution_item:hover{
      background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/home-bg03.png');
      background-size: cover;
      .solution_text01{
        color: #FFFFFF;
      }
      .solution_text02{
        color: #FFFFFF;
      }
    }
  }
}


/*pc  为企业数字化提供全方位服务  */ 
.mobile_enterprise_digitization_service{
  display: none;
}
.index_enterprise_digitization_service{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 40.3158rem;
  width: 100%;
  // background-color: rgb(239, 245, 255);
  h1{
    color: rgb(51, 51, 51);
    font-family: PingFang SC;
    font-size: $fontSize45;
    font-weight: 500;
    padding: 3rem 0;
  }
  .digital_solution_case {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    // height: 37.7368rem;
    width: 100%;
    .solution_img_box {
      height: 16.8421rem;
      width: 21.3158rem;
      margin-right: 1.5263rem;
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .solution_item {
      height: 16.8421rem;
      width: 28.89rem;
      margin: .6316rem;
      box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 0.5);
      border-radius: 8px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .solution_text01{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize32;
        font-weight: 500;
        margin-top: 1.125rem;
        margin-bottom: 1.2rem;
      }
      .solution_text02{
        color: rgb(51, 51, 51);
        font-family: PingFang SC;
        font-size: $fontSize14;
        text-align: center;
        width: 20rem;
      }
      .solution_img_wrapper{
        width: 4.16667rem;
        height: 4.16667rem;
        margin-top: 2.8rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .solution_item:hover{
      background: url('https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/home-bg03.png');
      background-size: cover;
      .solution_text01{
        color: #FFFFFF;
      }
      .solution_text02{
        color: #FFFFFF;
      }
    }
  }
}     

/* 多重安全合规资质  */
.mobile_fr_prize{
  display: none;
}
.index_fr_prize {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 28rem;
    width: 100%;
}

.index_fr_prize h2 {
    width: 100%;
    margin-top: 5.2632rem;
    text-align: center;
    font-size: $fontSize45;
    font-family: PingFang SC;
    font-weight: normal;
    color: #2F364C;
    line-height: 3.4211rem;
}

.index_fr_prize ul {
    display: flex;
    justify-content: center;
    height: 11.5789rem;
    width: 100%;
    margin-top: 1.5789rem;
    padding-inline-start: 0px;
}

.index_fr_prize ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 15.5263rem;
    width: 10.5263rem;
    margin: 0 4.2105rem 0 4.2105rem;
    list-style: none;
}

.index_fr_prize ul li img {
    height: 8.02rem;
    background: #FFFFFF;
    border-radius: 50%;
    margin-bottom: 1.8947rem;
    box-shadow: 0px 4px 14px 4px rgba(204, 213, 222, 0.5);
}

.index_fr_prize li p {
    height: 2.6316rem;
    width: 10.7368rem;
    font-size: $fontSize18;
    font-family: "PingFang-SC";
    font-weight: 400;
    color: rgb(102, 102, 102);
    line-height: 1.3158rem;
    text-align: center;
} 


/* 一站式出行行业数字化解决方案服务商 */ 
.free_use_buttton {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 18.33rem;
    background-image: url("https://yoogurt.oss-cn-hangzhou.aliyuncs.com/bbc/home-bg04.png");
    background-size: cover;
    .copy-right{
      color: rgb(51, 51, 51);
      font-size: $fontSize18;
      font-weight: 500;
      line-height: 1;
      letter-spacing: 0;
      text-align: center;
      margin-top: 2.5rem;
    }
}

.free_use_buttton h3 {
    margin: 4.211rem 0 .632rem 0;
    font-size: 1.684rem;
    font-family: "PingFang-SC";
    // font-weight: 600;
    color: #333333;
}

.free_use_buttton .free_use_buttton_btn1 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 19.474rem;
    height: 3.158rem;
    background: #0069EA;
    border-radius: 4px;
    margin-top: 2rem;
    cursor: pointer;
}

.free_use_buttton .free_use_buttton_btn1 span {
    font-size: $fontSize24;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}








.mobile_solution{
  display: none;
}
.index_digital_solution {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 52.3158rem;
    width: 100%;
    background-color: #FFFFFF;
}

.index_digital_solution h1 {
    font-size: 2.5263rem;
    font-family: "Alibaba-PuHuiTi";
    font-weight: normal;
    color: #2F364C;
    line-height: 3.4211rem;
    text-align: center;
}
@media (max-width: 1024px) {
    .index_digital_solution h1 {
        margin: -3.5rem 0 -1.5rem 0;
    }
}

.index_digital_solution .digital_solution_case {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    height: 37.7368rem;
    width: 100%;
}

.index_digital_solution .digital_solution_case .solution_img_box {
    height: 16.8421rem;
    width: 21.3158rem;
    margin-right: 1.5263rem;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;
}

.index_digital_solution .digital_solution_case img {
    width: 100%;
    height: 100%;
}

.digital_solution_case .solution_item {
    height: 16.8421rem;
    width: 21.3158rem;
    margin: .6316rem;
}
@media (max-width: 1024px) {
    .digital_solution_case .solution_item {
        margin: .2rem;
    }
    .digital_solution_case .solution_ite {
        width: 22rem;
    }
}

.digital_solution_case .solution_item h4 {
    position: relative;
    font-size: 1.684rem;
    font-family: "Alibaba-PuHuiTi";
    font-weight: normal;
    color: #FFFFFF;
    line-height: 2.5rem;
    top: 15.7rem;
    left: 2.105rem;
}

.digital_solution_case .solution_item .active {
    filter: blur(4px);
}

.digital_solution_case .solution_text {
    display: none;
    position: relative;
    flex-direction: column;
    padding: 20px;
    margin-top: -72%;
    margin-left: 5%;
    flex-direction: column;
}
@media (max-width: 1024px) {
    .digital_solution_case .solution_text {
        margin-left: 0;
    } 
}

.digital_solution_case .solution_text img {
    height: 12px;
    width: 12px;
}

.digital_solution_case .solution_text span {
    margin-bottom: 5%;
}

.digital_solution_case .solution_text a {
    font-family: "PingFang-SC";
    color: #FFFFFF;
}

.digital_solution_case .solution_text span:nth-child(1) {
    position: relative;
    font-size: 1.5789rem;
    font-family: "Alibaba-PuHuiTi";
    font-weight: normal;
    color: #FFFFFF;
    line-height: 2.2105rem;
}

.digital_solution_case .solution_text span:nth-child(2) {
    font-size: .8421rem;
    font-family: "PingFang-SC";
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1.2632rem;
    letter-spacing: .0526rem;
}

.digital_solution_case .solution_text span:nth-child(3) {
    font-size: 1.0526rem;
    font-family: "PingFang-SC";
    font-weight: 500;
    color: #FFFFFF;
    line-height: 8.4737rem;
}

.digital_solution_case .solution_text span:nth-child(3) a {
    font-size: 1.4rem;
    font-family: "PingFang-SC";
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
}

.solution_item .hov-img{
  opacity: 0.3;
  /* visibility: hidden; */
  transition: all 1s;
}

.solution_item:hover .hov-img{
  opacity: 1;
  /* visibility: visible; */
  transition: all 1s;
}

.solution_item:hover .nor-img{
  display:none;
}
/* .solution_item .nor-img:hover {
  opacity: 1;
  visibility: visible;
  transition: opacity 1s ease;
} */



// 移动端
@media screen and (min-width: 300px) and (max-width: 768px) {
  [v-cloak]{
    display: none;
  }
  .home{
    width:100%;
    // color: $lightRed;
    .home-wrapper01{
      width: 100%;
      height: 35.42rem;
      background: url('../assets/images/home01.png');
      background-size: 100% 100%;
      .wrapper01-main{
        margin-left: 3rem;
        padding-top: 7.4rem;
        .text01{
          color: rgb(0, 105, 234);
          font-family: PingFang SC;
          font-size: $mFontSize12;
          font-weight: 400;
          line-height: $fontSize45;
          letter-spacing: 0px;
          text-align: left;
          margin-top: $fontSize45;
        }
        .text02{
          color: rgb(0, 105, 234);
          font-family: PingFang SC;
          font-size: $mFontSize16;
          font-weight: 400;
          line-height: $mFontSize20;
          letter-spacing: 0px;
          text-align: left;
          font-weight: 500;
        }
        .text03{
          color: rgb(51, 51, 51);
          font-family: PingFang SC;
          font-size: $mFontSize12;
          font-weight: 500;
          line-height: $fontSize30;
          letter-spacing: 0px;
          text-align: left;
          margin-top: $fontSize45;
        }
      }
    }
  }

  .index_home-wrapper02{
    display: flex;
    justify-content: space-around;
    margin-top: 4rem;
    padding: 0 1rem;
    padding-bottom: 2rem;
    .wrapper02-main01{
      display: flex;
      align-items: center;
      justify-content: center;
      .img01{
        width: 6.65rem;
        height: 6.875rem;
      }
      .img02{
        width: 2.5rem;
        height: 3rem;
      }
    }
    .wrapper02-main02{
      margin-top: $mFontSize12;
      font-size: $mFontSize12;
    }
  }

  .index_taxi_online_car{
    display: none;
  }

  .mobile_taxi_online_car{
    display: block;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 104rem;
    background-color: rgb(239, 245, 255);
    h1{
      font-size: 5.1429rem;
      margin: 5.2rem 0;
    }
    .mobile_solution_case {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 97.1429rem;
       
    }
    .mobile_solution_item {
        border-radius: 2px;
        height: 39.1429rem;
        width: 45.7143rem;
        background: #ffffff;
        margin: 0 1.2rem 2.4rem 1.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .solution_text01{
          font-size: $mFontSize16;
          margin:2rem 0;
        }
        .solution_text02{
          font-size: $mFontSize12;
          text-align: center;
        }
        .solution_img_wrapper{
          width: 40rem;
          height: 16rem;
          margin-top: 1.8rem;
          img{
            width: 100%;
            height: 100%;
          }
        }
    }
  }

  .index_data_visible{
    height: 85rem;
    h1{
      margin: 0;
      font-size: $mFontSize20;
      padding-top: 10rem;
      padding-bottom: 1rem;
    }
    .container {
      width: 90%;
    }
    .swiper {
      width: 100%;
      height: 56rem;
    }
    .swiper .swiper-slide {
      text-align: center;
      font-size: 16px;
      height: 54rem;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      cursor: pointer;
    }
    .swiper .swiper-slide img{
      // width: 100%;
      // height: 40rem;
      width: 67.23rem;
      height: 40rem;
    }
    .swiper-text{
      color: rgb(255, 255, 255);
      font-family: PingFang SC;
      font-size: $mFontSize12;
      z-index: 2;
      position: absolute;
      bottom: 0;
    }
    .swiper-button-prev, .swiper-button-next{
      top: 96%;
      width: 8rem;
      height: 8rem;
    }
    .swiper-button-prev{
      left: 100px;
    }
    .swiper-button-next{
      right: 100px;
    }
    .swiper-pagination{
      position: static;
      width: 80px;
      display: flex;
      justify-content: space-around;
      margin: $mFontSize12 auto;
    }
  }

  .index_module_service{
    display: none;
  }
  .mobile_module_service{
    display: block;
    display: flex;
    flex-direction: column;
    align-items: center;
    // height: 104rem;
    // background-color: rgb(239, 245, 255);
    h1{
      font-size: 5.1429rem;
      margin: 5.2rem 0;
    }
    .mobile_solution_case {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 97.1429rem;
       
    }
    .module_solution_item {
        border-radius: 2px;
        height: 39.1429rem;
        width: 45.7143rem;
        box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 0.5);
        margin: 0 1.2rem 2.4rem 1.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .solution_text01{
          font-size: $mFontSize16;
          margin:2rem 0;
        }
        .solution_text02{
          font-size: $mFontSize12;
          text-align: center;
        }
        .solution_img_wrapper{
          width: 16rem;
          height: 16rem;
          margin-top: 1.8rem;
          img{
            width: 100%;
            height: 100%;
          }
        }
    }
  }
  
  .index_enterprise_digitization_service{
    display: none;
  }
  .mobile_enterprise_digitization_service{
    display: block;
    display: flex;
    flex-direction: column;
    align-items: center;
    // height: 104rem;
    // background-color: rgb(239, 245, 255);
    h1{
      font-size: 5.1429rem;
      margin: 5.2rem 0;
    }
    .mobile_solution_case {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 97.1429rem;
       
    }
    .module_solution_item {
        border-radius: 2px;
        height: 43rem;
        width: 45.7143rem;
        box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 0.5);
        margin: 0 1.2rem 2.4rem 1.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .solution_text01{
          font-size: $mFontSize16;
          margin:1.8rem 0;
        }
        .solution_text02{
          font-size: $mFontSize12;
          text-align: center;
          margin: 0 1rem;
        }
        .solution_img_wrapper{
          width: 12rem;
          height: 12rem;
          margin-top: 1.8rem;
          img{
            width: 100%;
            height: 100%;
          }
        }
    }
  }

  .index_fr_prize{
    display: none;
  }
  .mobile_fr_prize {
    display: block;
    margin-top: 7rem;
    height: 50rem;
    width: 100.8571rem;
    background: #F5F9FF;
  }
  .mobile_fr_prize h2 {
    padding-top: 7rem;
    text-align: center;
    font-size: $mFontSize20;
    font-family: PingFang SC;
    font-weight: normal;
    color: rgb(0, 0, 0);
    margin-bottom: 4rem;
  }
  .mobile_fr_prize .fr_prize_swiper {
    display: flex;
    flex-direction: row;
    padding-left: 10rem;
  }
  .mobile_fr_prize .fr_prize_swiper .fr_prize_item {
    width: 32rem !important;
    height: 55rem !important;
    padding-top: 3.4286rem;
    margin-right: 8.5714rem;
    list-style: none;
  }
  .mobile_fr_prize .fr_prize_item img {
    height: 20rem;
    width: 20rem;
    border-radius: 50%;
    box-shadow: 0px 2px 30px 0px rgba(215, 226, 238, 0.6);
  }
  .mobile_fr_prize .fr_prize_item p {
    width: 29rem;
    text-align: center;
    margin-top: 3.4286rem;
  }
  .fr_prize_box {
    display: flex;
    flex-direction: row;
    overflow: scroll;
    padding-left: 10.7rem;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }
  .fr_prize_box::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .fr_prize_box .fr_prize_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 12rem;
  }

  .free_use_buttton {
    width: 100%;
    height: 170px;
    // margin-bottom: 24px;
    padding: 0 2rem;
    .copy-right{
      font-size: $mFontSize12;
      font-weight: normal;
    }
  }
  .free_use_buttton h3{
    font-size: $mFontSize16;
  }
  .free_use_buttton .free_use_buttton_btn1 {
    display: inline-block;
    width: 180px;
    height: 36px;
    margin-top: 4rem;
    text-align: center;
    line-height: 36px;
  }
  .free_use_buttton .free_use_buttton_btn1 span{
    font-size: 14px;
  }
  




  .index_digital_solution{
    display: none;
  }
    .mobile_solution {
      display: block;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 183rem;
        margin-bottom: 8rem;
        h1{
          font-size: 5.1429rem;
        }
    }
    .mobile_solution .mobile_solution_case {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 97.1429rem;
        height: 94%;
    }
    .mobile_solution .mobile_solution_case .img01 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%9C%B0%E4%BA%A7-nor-min.png");
        background-size: cover;
    }
    .mobile_solution .mobile_solution_case .img02 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%87%91%E8%9E%8D-nor-min.png");
        background-size: cover;
    }
    .mobile_solution .mobile_solution_case .img03 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E4%BA%A4%E9%80%9A-nor-min.png");
        background-size: cover;
    }
    .mobile_solution .mobile_solution_case .img04 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%93%B6%E8%A1%8C-nor-min.png");
        background-size: cover;
    }
    .mobile_solution .mobile_solution_case .img05 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%8C%BB%E8%8D%AF-nor-min.png");
        background-size: cover;
    }
    .mobile_solution .mobile_solution_case .img06 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E9%9B%B6%E5%94%AE-nor-min.png");
        background-size: cover;
    }
    .mobile_solution .mobile_solution_case .img07 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E7%94%B5%E5%8A%9B-nor-min.png");
        background-size: cover;
    }
    .mobile_solution .mobile_solution_case .img08 {
        background-image: url("https://src.fanruan.com/website/2022-finereport/img/index/2023-index/%E6%99%BA%E6%85%A7%E5%88%B6%E9%80%A0-nor-min.png");
        background-size: cover;
    }
     .mobile_solution .mobile_solution_item {
        border-radius: 2px;
        height: 39.1429rem;
        width: 45.7143rem;
    }
     .mobile_solution span a {
        position: relative;
        top: 30.2rem;
        left: 4.3rem;
        font-size: 4.2857rem;
        font-family: "Alibaba-PuHuiTi";
        font-weight: normal;
        color: #FFFFFF;
        line-height: 6rem;
    }
     .mobile_solution span i {
        font-size: 2.7397rem;
    }
    .mobile_solution .mobile_solution_case .mobile_solution_item {
        margin: 0 1.2rem 2.4rem 1.2rem;
    }
}
</style>
